/**
 * 「静默加购」（设置项 settings.silent_add_to_cart，开启后 cart-notification 带 .silent-add 类）
 *
 * 目标：加购后不打开抽屉、不弹窗、不跳转，只更新购物车数量并弹一个轻量提示（toast）。
 *      购物车图标点击行为不受影响（由 minicart_header.liquid 控制，静默模式下直接跳转 /cart 页）。
 * 关键点：加购后的自动打开会调用 cart-notification 的 open()。我们只在「刚发生过 /cart/add」
 *        的短暂窗口内、且元素带 .silent-add 类时压制 open()，其余情况一律放行原逻辑。
 */
(function () {
  "use strict";

  // 记录最近一次加购请求完成的时间；open() 命中该窗口即视为「加购触发的自动打开」
  var suppressUntil = 0;

  // 匹配 /cart/add（兼容多语言前缀如 /en/cart/add 及 .js 后缀）
  function isAddRequest(url) {
    return typeof url === "string" && url.indexOf("/cart/add") !== -1;
  }

  // 包裹 fetch，仅对加购请求打时间戳，其余请求原样透传
  var originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function (input, init) {
      var url = "";
      try {
        url = typeof input === "string" ? input : (input && input.url) || "";
      } catch (e) {}
      var promise = originalFetch.apply(this, arguments);
      if (isAddRequest(url)) {
        promise = promise.then(function (response) {
          // 覆盖紧随其后的 open()（内部还有一次 /cart.json 与 section 重渲染）
          suppressUntil = Date.now() + 2500;
          return response;
        });
      }
      return promise;
    };
  }

  var CHECK_ICON =
    '<span class="toast-added__icon" aria-hidden="true">' +
    '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2.5 8.5L6 12L13.5 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    "</svg></span>";

  function showAddedToast(el) {
    if (typeof window.showToast !== "function") return;
    var msg = (el && el.getAttribute("data-added-text")) || "Item added to your cart";
    window.showToast(CHECK_ICON + '<span class="toast-added__text">' + msg + "</span>", 2500, "toast-added");
  }

  function patch(Ctor) {
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__silentAddPatched) return;
    Ctor.prototype.__silentAddPatched = true;
    var originalOpen = Ctor.prototype.open;
    if (typeof originalOpen !== "function") return;
    Ctor.prototype.open = function () {
      if (this.classList.contains("silent-add") && Date.now() < suppressUntil) {
        suppressUntil = 0; // 消费掉本次窗口
        showAddedToast(this);
        return;
      }
      return originalOpen.apply(this, arguments);
    };
  }

  ["cart-notification", "cart-drawer"].forEach(function (name) {
    if (customElements.get(name)) {
      patch(customElements.get(name));
    } else if (customElements.whenDefined) {
      customElements.whenDefined(name).then(function () {
        patch(customElements.get(name));
      });
    }
  });
})();
